import { render, staticRenderFns } from "./createallocationrules.vue?vue&type=template&id=5b6da78e&"
import script from "./createallocationrules.vue?vue&type=script&lang=ts&"
export * from "./createallocationrules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createallocationrules.vue"
export default component.exports